import React from 'react';
import PropTypes from 'prop-types';

const NotesPanel = (props) => {

    const {orderDetails} = props;

    if (!orderDetails) {
        return null;
    }

    const workOrderEntryComments = orderDetails.get('workOrderEntryComments');
    let workOrderEntryCommentList = null;
    let workOrderComments = 'N/A';

    if (workOrderEntryComments && workOrderEntryComments.count() > 0) {
        workOrderEntryCommentList = workOrderEntryComments.map((wc, index) => {
            return (
                <div key={'wc_' + index}>{wc.get('comment')}
                    <br/></div>
            );
        });
    }

    if (orderDetails.get('workOrderComments')) {
        workOrderComments = orderDetails
            .get('workOrderComments')
            .trim() || 'N/A';
    }

    let dispatchCommentsRow = null,
        orderEntryCommentsRow = null;

    if (orderDetails.get('dispatchComments')) {
        dispatchCommentsRow = (
            <div className="row">
                <div className="col s12 m12 l12">
                    <label>Dispatch Comments:
                    </label>
                </div>
                <div className="col s12 m12 l12">
                    {orderDetails.get('dispatchComments')}
                </div>
            </div>
        );
    }

    if (workOrderEntryCommentList) {
        orderEntryCommentsRow = (
            <div className="row">
                <div className="col s12 m12 l12">
                    <label>Order Entry Comments:
                    </label>
                </div>
                <div className="col s12 m12 l12">
                    {workOrderEntryCommentList}
                </div>
            </div>
        );
    }

    return (
        <div
            className="text-align-left"
            style={{
            paddingTop: '10px',
            paddingLeft: '10px',
            paddingRight: '10px'
        }}>
            <div className="row">
                <div className="col s12 m12 l12">
                    <label>Work Order Comments:
                    </label>
                </div>
                <div className="col s12 m12 l12">
                    {workOrderComments}
                </div>
            </div>
            {dispatchCommentsRow}
            {orderEntryCommentsRow}

        </div>
    );

};

NotesPanel.propTypes = {
    orderDetails: PropTypes.object
};

export default NotesPanel;


// WEBPACK FOOTER //
// ./src/components/work-order/NotesPanel.js